import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardHeaderContainer,
  CardBody,
  CardFooter,
  HeaderTitle,
  HeaderSubtitle,
  BodyText,
} from './elements';

const CardHeader = ({ title, subtitle }) => (
  <CardHeaderContainer>
    <HeaderTitle>{title}</HeaderTitle>
    <HeaderSubtitle>{subtitle}</HeaderSubtitle>
  </CardHeaderContainer>
);

CardHeader.defaultProps = {
  title: '',
  subtitle: '',
};

CardHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export { Card, CardFooter, CardBody, CardHeader, BodyText };
